<template>
  <div
    class="card card-custom card-stretch mt-5 gutter-b pl-0 pr-0 pb-5 mb-4 model_by_ch_top"
    style="background: transparent;"
  >
    <!--begin::Header-->
    <div class="row m-0 col-12 p-2 border-r-16" style="padding-left: 10px;">
      <div class="col-md-4 p-0">
        <span class="leatext_job_heading_by_new_home">Job Applications</span>
      </div>
      <div class="col-md-8 p-0 row m-0" style="align-items: center">
        <router-link
          class="text-end"
          style="
              font-size: 16px;
              color: rgb(3, 169, 244) !important;
              text-decoration: underline !important;
            "
          :to="{ path: '/job-seeker/my-job-applications' }"
        >
          view all applications</router-link
        >
      </div>
    </div>
    <div class="px-4" data-app>
      <!-- <hr
        class="col-md-12 p-0 mt-4"
        style="background: rgba(53, 162, 229, 0.25)"
      /> -->
      <div class="row">
        <div class="col-md-12 row m-0 mt-4 pt-0 pr-0 pl-0">
          <div class="empty_div_jobsAdd" v-if="data.length == 0">
            You don't have any job Application.
          </div>
          <!-- //////////////////////////////////start -->
          <div
            class="col-md-4 row m-0 mt-4 pt-0 pl-0 "
            v-for="(item, index) in data"
            :key="index"
          >
            <div
              class=" col-md-12  row m-0 border-r-16 p-4 bg-white"
              v-if="item.job != null"
              :id="
                'jobseeker_app_' +
                  item.recruiter_profile.company_name
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '') +
                  '_' +
                  item.job.job_title
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '')
              "
              :class="
                detail1 && detail1.id === item.id
                  ? 'bg-info-new'
                  : 'bg-white' && detail2 && detail2.id === item.id
                  ? 'bg-info-new'
                  : 'bg-white' && detail3 && detail3.id === item.id
                  ? 'bg-info-new'
                  : 'bg-white' && detail4 && detail4.id === item.id
                  ? 'bg-info-new'
                  : 'bg-white'
              "
            >
              <!-- <div class="col-md-12 p-0">
              <v-checkbox
                class="p-0 m-0"
                color="secondary"
                hide-details
                @change="
                  bulkAction($event, item)"
              ></v-checkbox>
            </div> -->
              <div
                class="col-md-4 p-0  circular--portrait pic_border"
                style="position: relative"
              >
                <!-- :src="mediaUrl + item.recruiter_profile.profile_pic" -->
                <img
                  @error="onImageLoadFailure($event)"
                  :src="mediaUrl + item.recruiter_profile.profile_pic || ''"
                  alt="Profile Image"
                  id="img_profile"
                />
                <!-- <v-btn
                icon
                :style="item.favorite == 'yes' && 'color: orange'"
                @click="favoriteClick(item.id)"
                class="style_madi_star_n shadow"
              >
                <v-icon>mdi-star</v-icon>
              </v-btn> -->
              </div>
              <div class="col-md-8 p-0">
                <div
                  style="
                  border: 1.5px solid rgb(53, 162, 229);
                  font-size: 12px;
                  padding: 2px 16px;
                  border-radius: 4px;
                  color: rgb(53, 162, 229);
                  width: fit-content;
                  position: absolute;
                  right: -7px;
                  top: 20px;
                  text-align: center;
                  background-color: transparent;
                "
                >
                  {{ item.status }}
                </div>
              </div>
              <div class="col-md-12 p-0">
                <span
                  class="label label-info"
                  style="
                  margin: 13px 0 8px 0;
                  background: #e80000;
                  width: auto !important;
                  padding: 0 8px !important;
                  border-radius: 16px !important;
                  font-size: 14px;
                "
                  v-if="
                    item.notification ? item.notification.seen_at == null : ''
                  "
                  >new</span
                >
              </div>
              <div class="col-md-12 p-0 mt-4">
                <h4
                  class="mb-0"
                  style="color: #242424; font-size: 18px; font-weight: bold"
                >
                  {{ item.recruiter_profile.company_name }}
                </h4>
              </div>
              <div class="col-md-12 p-0">
                <p class="m-0" style="color: #666; font-size: 14px">
                  Applied for {{ item.job.job_title }}
                </p>
              </div>
              <div class="col-md-12 p-0">
                <p class="m-0" style="color: #666; font-size: 11px">
                  applied:
                  {{ moment(item.job.created_at).format("DD MMM, YY. hh:mmA") }}
                </p>
                <hr
                  class="col-md-12 p-0 mt-4"
                  style="background: rgba(53, 162, 229, 0.25)"
                />
              </div>

              <router-link
                class="col-12 p-0 pt-3 text-center"
                style="width: 100%;background: rgba(53, 162, 229, 0.05);border: 1px solid rgba(53, 162, 229, 0.5);border-radius: 4px;padding: 5px !important;"
                :to="`/job-seeker/my-job-applications?${item.id}`"
              >
                View Application</router-link
              >
            </div>
          </div>
          <!-- ////////////////////////////////// -->
        </div>
      </div>

      <!-- Confirm Withdraw Item -->
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="380px">
          <v-card>
            <v-card-title>
              <span class="headline"
                >Do you really want to withdraw your request?</span
              >
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="custom-submit-button" text @click="dialog = false"
                >No</v-btn
              >
              <v-btn class="custom-cancel-button" text @click="deleteItem"
                ><b-spinner small type="grow" v-if="deleting"></b-spinner
                >Withdraw Request</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <!-- Send Message Popup -->
      <v-row justify="center">
        <v-dialog
          v-model="sendMsgPopup"
          persistent
          max-width="600px"
          style="overflow-x: hidden"
        >
          <v-card>
            <v-card-title>
              <span class="headline">Send direct message</span>
            </v-card-title>
            <div class="row" style="padding-left: 6%; padding-right: 6%">
              <div class="col-md-12">
                <v-text-field
                  v-model="message_title"
                  label="Subject"
                ></v-text-field>

                <v-file-input
                  style="font-size: 8px"
                  label="file"
                  @change="Preview_image"
                  v-model="file"
                >
                </v-file-input>
              </div>

              <label>Message</label>
              <vue-editor
                style="width: 100%; height: 80%"
                v-model="message"
              ></vue-editor>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                class="custom-submit-button"
                text
                @click="sendMsgPopup = false"
                >Cancel</v-btn
              >
              <v-btn class="custom-cancel-button" text @click="sendMsg"
                ><b-spinner small type="grow" v-if="deleting"></b-spinner
                >Send</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
    <hr
      class="col-md-12 p-0 mt-4"
      style="background: rgba(53, 162, 229, 0.25)"
    />
  </div>
</template>

<script>
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";
import Swal from "sweetalert2";
import JobSeekerService from "@/MainServices/JobSeekerService.js";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import { VueEditor } from "vue2-editor";
import moment from "moment";

export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      profile: JSON.parse(localStorage.getItem("profile")),
      mediaUrl: MEDIA_URL,
      statusItems: [
        "All",
        "Applied",
        "Shorlisted",
        "Call For Interview",
        "interviewed",
        "Selected",
      ],
      filter: "",
      thisJobId: 0,
      search: "",
      loading: true,
      dialog: false,
      deleteId: null,
      deleting: false,
      success: false,
      token: `Bearer ${localStorage.getItem("token")}`,
      valid: true,

      headers: [
        { text: "COMPANY", value: "name" },
        { text: "JOB TITLE", value: "title" },
        { text: "STATUS", value: "status" },
        { text: "ACTIONS", value: "action" },
      ],
      data: [],
      originalData: [],
      bulkActionArr: [],
      activeVideo: "",
      sendMsgPopup: false,
      msgUser: null,
      message_title: "",
      message: "",
      file: null,
      file_url: null,
      jobId: null,
      conversation: [],
      messages: [],
      msg_limat: "",
      msg_limat2: "",
      filter_tital: "",
      filter_jobsekeer: "",
      job_titals: ["All"],
      job_jobsekeer: ["All"],
      detail1: null,
      detail2: null,
      detail3: null,
      detail4: null,
      alwyes: true,
    };
  },
  mounted() {
    window.Echo.channel("channel").listen("Notifications", (e) => {
      var thisUser = false;

      for (let index = 0; index < e.threads.length; index++) {
        if (
          this.thisJobId == e.threads[index].job_id &&
          (e.seeker_id == e.threads[index].receiver_id ||
            e.seeker_id == e.threads[index].sender_id)
        ) {
          thisUser = true;
          break;
        }
      }

      if (thisUser == true) {
        this.conversation = [];
        this.messages = [];
        let messages = [];
        e.inbox.map((data) => data.map((msg) => messages.push(msg)));
        messages = messages.sort((msg1, msg2) =>
          moment(msg1.created_at)
            .format("X")
            .localeCompare(moment(msg2.created_at).format("X"))
        );
        // .reverse();
        this.conversation = e;
        this.messages = messages;
      }
    });

    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    this.getInititalData();
  },
  components: {
    videoPlayer,
    VueEditor,
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  methods: {
    notification_read(id) {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios.post(`${API_URL}/notifications-read`, { id: id }).then((res) => {});
    },
    msg_notification_Bulk(item) {
      let ids = item.job.threads;
      var count_threds = [];
      ids.forEach((element) => {
        count_threds.push(element.id);
      });
      let receiver_id = this.profile.user_id;
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API_URL}/msg-notifications-Bulk`, {
          id: count_threds,
          receiver_id: receiver_id,
        })
        .then((res) => {});
    },
    moment: function(item) {
      if (item) {
        return moment(String(item));
      }
    },
    onImageLoadFailure(event) {
      event.target.src = "../images/profile_ch.jpg";
    },
    getInititalData() {
      JobSeekerService.getJobApplications()
        .then((res) => {
          this.loading = false;
          var temp = [];
          res.data.forEach((element) => {
            this.job_titals.push(element.job.job_title);
            this.job_jobsekeer.push(element.recruiter_profile.company_name);
            element.videoPlayer1 = {
              // videojs options
              muted: true,
              language: "en",
              playbackRates: [0.7, 1.0, 1.5, 2.0],
              sources: [
                {
                  type: "audio/wav",
                  src: this.mediaUrl + "videos/raw/" + element.intro_audio,
                },
              ],
              poster: "/static/images/author.jpg",
            };
            element.videoPlayer = {
              // videojs options
              muted: true,
              language: "en",
              playbackRates: [0.7, 1.0, 1.5, 2.0],
              sources: [
                {
                  type: "video/mp4",
                  src: this.mediaUrl + "/videos/raw/" + element.intro_video,
                },
              ],
              poster: "/static/images/author.jpg",
            };
            var msgs_counts = 0;

            element.job.threads.map((el) => {
              el.msgs.map((e) => {
                if (
                  e.receiver_id == this.profile.user_id &&
                  e.seen_at == null
                ) {
                  msgs_counts++;
                }
              });
            });
            element.msgs_counts = msgs_counts;
            // temp.push(element);
            temp.push(element);
          });
          this.data = temp;
          this.originalData = temp;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    favoriteClick(id) {
      RecruiterService.changeJobApplicationFavoriteStatus(id)
        .then((res) => {
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    singleDetail1(item) {
      this.detail1 = item;
      this.detail2 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail11(item) {
      this.detail1 = item;
      this.detail2 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail2(item) {
      this.detail2 = item;
      this.detail1 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail22(item) {
      this.detail2 = item;
      this.detail1 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail3(item) {
      this.detail3 = item;
      this.getConversation(item);
      this.detail2 = false;
      this.detail1 = false;
      this.detail4 = false;
      this.alwyes = false;
    },
    singleDetail4(item) {
      this.detail4 = item;
      this.detail2 = false;
      this.detail3 = false;
      this.detail1 = false;
      this.alwyes = false;
    },
    filterData() {
      var temp = [];
      var val = this.filter;
      if (val == "All") {
        this.data = this.originalData;
      } else {
        this.originalData.forEach((element) => {
          if (element.status == val) {
            temp.push(element);
          }
        });
        this.data = temp;
      }
    },
    clearFilter() {
      this.filter = "";
      this.filter_jobsekeer = "";
      this.filter_tital = "";
      this.getInititalData();
    },
    filterbyjobsekeer(val) {
      if (val == "All") {
        this.data = this.originalData;
      } else {
        this.data = this.originalData.filter((element) =>
          element.recruiter_profile.company_name
            .toLowerCase()
            .includes(val.toLowerCase())
        );
      }
    },
    filtertital(val) {
      if (val == "All") {
        this.data = this.originalData;
      } else {
        this.data = this.originalData.filter((element) =>
          element.job.job_title.toLowerCase().includes(val.toLowerCase())
        );
      }
    },
    bulkAction(event, id) {
      var newArr = [];
      if (event == true) {
        newArr.push(id);
        this.bulkActionArr = newArr;
      } else {
        newArr = this.bulkActionArr.filter((item) => {
          return item !== id;
        });
        this.bulkActionArr = newArr;
      }
    },

    bulkActionProceed(val) {
      if (val !== "All") {
        RecruiterService.changeJobApplicationStatus({
          ids: this.bulkActionArr,
          status: val,
        })
          .then((res) => {
            Swal.fire({
              title: "",
              text: res.data,
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
            this.getInititalData();
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    downloadCV(path) {
      if (path) {
        window.open(this.mediaUrl + path, "_blank");
      } else {
        Swal.fire({
          title: "",
          text: "No CV is available. Please Add your CV.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      }
    },
    view_CV(path) {
      if (path) {
        // window.open("/cv-view?path=" + path.replace(/\//g, "-"), "_blank");
        https: window.open(
          "https://docs.google.com/gview?url=" +
            this.mediaUrl +
            path +
            "&embedded=true",
          "_blank"
        );
      } else {
        Swal.fire({
          title: "",
          text: "No CV is available. Please Add your CV.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      }
    },

    withdrawApplication(id) {
      JobSeekerService.withdrawJobApplication(id)
        .then((res) => {
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.dialog = false;
          this.loading = false;
          this.success = true;
          this.submitting = false;
          this.getInititalData();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },

    deleteItem() {
      this.withdrawApplication(this.deleteId);
    },

    Preview_image() {
      this.file_url = this.file;
    },

    sendMsgPopupHandler(item) {
      this.sendMsgPopup = true;
      this.msgUser = item.recruiter_id;
      this.jobId = item.job_id;
      this.job_app_id = item.id;
    },

    resetSendMsg() {
      this.msgUser = null;
      this.message_title = "";
      this.message = "";
      this.file = null;
      this.file_url = null;
      this.sendMsgPopup = false;
      this.jobId = null;
      setTimeout(() => {
        this.chat_to_bottom();
      }, 100);
    },

    sendMsg(item) {
      this.msgUser = item.recruiter_id;
      this.jobId = item.job_id;
      this.job_app_id = item.id;
      let formData = new FormData();
      formData.append("message_title", this.message_title);
      formData.append("job_id", this.jobId);
      formData.append("message", this.message);
      formData.append("receiver_id", this.msgUser);
      formData.append("file", this.file_url);
      formData.append("job_app_id", this.job_app_id);

      axios.defaults.headers.common["Authorization"] = this.token;
      axios.post(`${API_URL}/send-message`, formData).then((res) => {
        // Swal.fire({
        //   title: "",
        //   text: res.data,
        //   icon: "success",
        //   confirmButtonClass: "btn btn-secondary",
        //   heightAuto: false,
        // });
        this.getInititalData();
        this.resetSendMsg();
      });
    },
    msg_limat_var() {
      if (this.messages.length > 0) {
        var last = this.messages[this.messages.length - 1].sender_id;
        var send_last = this.messages[this.messages.length - 2].sender_id;
        if (last == this.profile.user_id && send_last == this.profile.user_id) {
          return false;
        }
        return true;
      } else {
        return true;
      }
    },
    secrollottom() {
      var container_box = document.getElementById("chat_box_secroll");
      container_box.scrollTop = container_box.offsetHeight;
      console.log("container_box", container_box);
    },
    getConversation(item) {
      this.thisJobId = item.job_id;
      this.messages = [];
      JobSeekerService.getConversations(item.job_id).then((res) => {
        const messages = [];
        res.data.map((conversation) =>
          conversation.messages.map((msg) => messages.push(msg))
        );
        messages.sort((msg1, msg2) =>
          moment(msg1.created_at)
            .format("X")
            .localeCompare(moment(msg2.created_at).format("X"))
        );
        this.conversation = res.data;
        this.messages = messages;
        setTimeout(() => {
          this.chat_to_bottom();
        }, 100);
      });
    },
    chat_to_bottom() {
      $(".chat_box_whit_new_styleCH_child").scrollTop(
        $(".chat_box_whit_new_styleCH_child")[0].scrollHeight
      );
    },
  },
};
</script>
<style scoped>
.circular--portrait {
  position: relative;
  width: 200px;
  overflow: hidden;
  border-radius: 50%;
}
.circular--portrait img {
  width: 100%;
  height: auto;
}
.pic_border {
  border: 1px solid #b9e5fb;
  margin-right: 0px;
}
</style>
